import NotFoundBar from '../components/Main/NotFoundBar';

const NotFoundPage = () => {
  return (
    <main>
      <NotFoundBar />
    </main>
  );
};

export default NotFoundPage;
